import { render, staticRenderFns } from "./DetailNew.vue?vue&type=template&id=93322fba&"
import script from "./DetailNew.vue?vue&type=script&lang=js&"
export * from "./DetailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports